"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeConfigStore = exports.IkeConfig = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const util_1 = require("../util");
/**
 *
 */
class IkeConfig {
    constructor(system, env, defaults) {
        this.services = [];
        this.system = system;
        this.env = env;
        // This allows a config to be created with defaults. Useful
        // when passing variables into the client-side app from the build
        // pipeline or web server
        this.config = Object.assign({}, defaults);
    }
    /**
     * Is this config for a production like environment
     *
     * eg Production or Preview
     */
    get isProduction() {
        return this.env === core_api_1.IkeEnvironment.PRODUCTION;
    }
    set(key, value) {
        this.config[key] = value;
    }
    /**
     * Determine if the key has a value
     *
     * not null or not empty string
     *
     * @param key key to check
     */
    has(key) {
        const val = this.config[key];
        return val != null && val !== '';
    }
    /** Unset a key */
    delete(key) {
        delete this.config[key];
    }
    /**
     *
     * @param key Config key to fetch
     * @deprecated Use specific typed getters instead
     */
    get(key) {
        return this.config[key];
    }
    /**
     * Converts a config value to a number if it is a number
     * @returns value as a number (float) null if the value could not be parsed or undefined if the key is not set
     */
    getNumber(key) {
        const val = this.config[key];
        if (val === undefined) {
            return undefined;
        }
        return util_1.IkeNumber.toNumber(this.config[key]);
    }
    /**
     * attempts to convert a config value to a boolean
     * boolean true and string 'true' return true
     * all other values return false
     * @param key Config key to fetch
     * @returns value as a boolean (true/false)
     */
    getBoolean(key) {
        const val = this.config[key];
        if (val == null) {
            return false;
        }
        if (typeof val === 'boolean') {
            return val;
        }
        if (typeof val === 'string') {
            return val.toLowerCase() === 'true';
        }
        return false;
    }
    getString(key) {
        const val = this.config[key];
        if (val == null) {
            return undefined;
        }
        if (typeof val === 'string') {
            return val;
        }
        if (typeof val === 'number') {
            return val.toString();
        }
        if (typeof val === 'boolean') {
            return val ? 'true' : 'false';
        }
        if (Array.isArray(val)) {
            return val.join(',');
        }
        if (typeof val === 'object') {
            return JSON.stringify(val);
        }
        return undefined;
    }
    mustGetString(key) {
        const value = this.getString(key);
        if (value === undefined) {
            throw new Error(`IkeConfig.mustGetString: required key "${key}" was not found in the config`);
        }
        return value;
    }
    /**
     * Get a config key if it is null return the default value
     *
     * @param key Config key to fetch
     * @param defaultValue Default value to return if key is not found
     */
    getDefaultNumber(key, defaultValue) {
        const num = this.getNumber(key);
        if (num == null) {
            return defaultValue;
        }
        return num;
    }
    /**
     * Check whether all the keys are present in the config.
     *
     * @param keys List of keys that are required .
     * @returns True if a key is missing, false otherwise.
     */
    requires(keys) {
        return keys.find(k => this.config[k] == null) != null;
    }
    missing(keys) {
        return keys.filter(k => this.config[k] == null);
    }
    /**
     * Register that a service was created with this config,
     * This is used to close the service we the config is destroyed
     * @param service
     */
    register(service) {
        this.services.push(service);
    }
    /** Wait for all services that have been bound to this account to close before closing the config */
    close() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield Promise.all(this.services.map(s => s.close()));
            this.services = [];
        });
    }
    /**
     * Copy all config variables from another IkeConfig
     * @param other
     */
    extend(other) {
        Object.keys(other.toJSON().keys).forEach(k => this.set(k, other.get(k)));
    }
    toJSON() {
        return {
            env: this.env,
            system: this.system,
            keys: this.config
        };
    }
    toString() {
        return `Config: ${this.system}:${this.env}`;
    }
}
exports.IkeConfig = IkeConfig;
class IkeConfigStore {
    static get(system, env) {
        var key = IkeConfigStore.makeKey(system, env);
        var store = IkeConfigStore.stores[key];
        if (store == null) {
            throw new Error('Invalid system/environment combination: ' + key);
        }
        return store;
    }
    static register(cfg) {
        var key = IkeConfigStore.makeKey(cfg.system, cfg.env);
        var store = IkeConfigStore.stores[key];
        if (store != null) {
            throw new Error('Store has already been registered: ' + cfg.toString());
        }
        IkeConfigStore.stores[key] = cfg;
    }
    static makeKey(system, env) {
        return `${system}:${env}`.toLowerCase();
    }
}
exports.IkeConfigStore = IkeConfigStore;
IkeConfigStore.stores = {};
IkeConfigStore.MAX_SEARCH_LENGTH = 512;
//# sourceMappingURL=store.js.map